import { Button, Icon } from '@kpa/kul';
import styles from './Header.module.css';
import { useNavigate } from 'react-router-dom';
import { FC } from 'react';

const Logout: FC = () => {
  const nav = useNavigate();
  return (
    <div className={styles.logout}>
      <Button variant="navigation" onClick={() => nav('/logga-ut')}>
        <Icon color="backgroundPrimary" name="IconSignOut" size="medium" />
        Logga ut
      </Button>
    </div>
  );
};

export default Logout;
